module.exports = __webpack_public_path__ + "static/media/scaLogo.f550550b.svg";